import { Button, Space, Tag } from '@yimoka/antd';

import { useTranslation } from '@/locales/i18n';

export interface StatusToggleActionProps {
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: boolean) => void;
  value?: boolean;
}

/** 列表状态用标签展示、用显式动作修改，避免把即时副作用伪装成表单开关。 */
export function StatusToggleAction({ disabled, loading, onChange, value = false }: StatusToggleActionProps) {
  const { t } = useTranslation();

  return (
    <Space size="small">
      <Tag color={value ? 'success' : 'default'}>
        {t(value ? 'Common:enabled' : 'Common:disabled')}
      </Tag>
      <Button
        danger={value}
        disabled={disabled}
        loading={loading}
        size="small"
        type="link"
        onClick={() => onChange(!value)}
      >
        {t(value ? 'Common:disable' : 'Common:enable')}
      </Button>
    </Space>
  );
}

export default StatusToggleAction;
